import infoTemplate from './info.html';

const SELECTED_ORG_LOCAL_STORAGE_KEY = 'Selected-Org';

export default angular
  .module('main.organizations.edit.tabs.info', [])

  .directive('editOrganizationInfoTab', () => {
    return {
      restrict: 'E',
      template: infoTemplate,
      scope: {},
      controller: ($scope,
                   $state,
                   $rootScope,
                   $q,
                   $filter,
                   utils,
                   ToastsService,
                   EditOrganizationDataProvider,
                   PermissionsService) => {
        const $t = $filter('translate');

        const ORGANIZATION_INFO = [
          'name',
          'domainName',
          'addrCity',
          'zip',
          'addrStreet1',
          'addrStreet2',
        ];

        $scope.dataProvider = EditOrganizationDataProvider.instance;

        // #region Form Controls

        $.fn.form.settings.rules.zipRule = function(value) {
          if (!value) {
            return true;
          }
          if ($scope.helpers.selectedCountry && $scope.helpers.selectedCountry.zipFormat) {
            return new RegExp($scope.helpers.selectedCountry.zipFormat).test(value);
          }
          return true;
        };

        $('#form-info').form({
          inline: true,
          fields: {
            orgName: {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.orgs.name.empty')
                }
              ]
            },
            domainName: {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.orgs.domainName.empty')
                }, {
                  type: 'regExp[/^[a-z0-9_-]{3,16}$/gi]',
                  prompt: $t('prompt.orgs.domainName.reg')
                }
              ]
            },
            zip: {
              rules: [
                {
                  type: 'zipRule',
                  prompt: $t('prompt.zip.reg')
                }
              ]
            }
          }
        });

        // #endregion

        angular.extend($scope, {
          helpers: {},
          onCancelButtonClick: onCancelButtonClick,
          copyToClipboard: $rootScope.copyToClipboard,
          canSaveOrganization: canSaveOrganization,
          saveOrganization: saveOrganization,
          changeCountry: changeCountry,
          switchOrg: switchOrg,
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.availableOrganizationsResource.init(),
            $scope.dataProvider.organizationResource.init(),
            $scope.dataProvider.countriesResource.init(),
          ])
            .then(() => {
              initOrganizationInfoModel();
              $scope.loading = false;
            }, () => {
              $scope.loading = false;
            });
        }

        function initOrganizationInfoModel() {
          $scope.organization = angular.copy($scope.dataProvider.organizationResource.value);
          $scope.countries = angular.copy($scope.dataProvider.countriesResource.value);

          // Get parent organization information
          $scope.canIViewParent = false;
          if ($scope.organization && $scope.organization.parentId) {
            let availableOrgs = $scope.dataProvider.availableOrganizationsResource.value || [];
            $scope.parentOrgInfo = availableOrgs.find(el => el.id === $scope.organization.parentId);
            $scope.canIViewParent = PermissionsService.canIViewOrganization($scope.parentOrgInfo);
          }

          initBrandsList();
          initSelectedCountryAndState();
          initWatchers();
        }

        function initWatchers() {
          $scope.$watchGroup(['helpers.selectedCountryId', 'helpers.selectedCountry'], function() {
            $scope.changeCountry();
          });
        }

        function changeCountry() {
          if ($scope.helpers.selectedCountry) {
            $scope.states = $scope.helpers.selectedCountry.states;
            $scope.timezones = $scope.helpers.selectedCountry.timezones;

            // Test if initial TZ is in country TZ list
            if ($scope.dataProvider.organizationResource.value.timezone && $scope.timezones && $scope.timezones.length > 0) {
              let testTimezone = $scope.timezones.some(el => el.id === $scope.dataProvider.organizationResource.value.timezone.id);
              if (!testTimezone) {
                $scope.timezones.unshift(angular.copy($scope.dataProvider.organizationResource.value.timezone));
              }
            }

            let sameCountry = !!($scope.helpers.selectedCountry && $scope.dataProvider.organizationResource.value.country && $scope.helpers.selectedCountry.id === $scope.dataProvider.organizationResource.value.country.id);
            let selectedStateId = $scope.states ? $scope.states[0].id : null;
            let selectedTimezoneId = $scope.timezones ? $scope.timezones[0].id : null;

            // Define state
            $scope.helpers.selectedStateId = sameCountry && $scope.dataProvider.organizationResource.value.state && $scope.dataProvider.organizationResource.value.state.id
              ? $scope.dataProvider.organizationResource.value.state.id
              : selectedStateId;

            // Define timezone
            $scope.helpers.selectedTimezoneId = sameCountry && $scope.dataProvider.organizationResource.value.timezone && $scope.dataProvider.organizationResource.value.timezone.id
              ? $scope.dataProvider.organizationResource.value.timezone.id
              : selectedTimezoneId;

            $scope.timezones = $scope.timezones?.map(tz => {
              return {
                ...tz,
                gmt: getTimezoneGmtString(tz) // Additional field for dropdown
              };
            });

          } else {
            $scope.states = null;
            $scope.timezones = null;
          }
        }

        /**
         * Get GMT string for timezone
         * @param {{id: string, offset: number, ...}} timezone
         * @return {string}
         */
        function getTimezoneGmtString(timezone) {
          let prefix = timezone.offset < 0 ? '-' : '+';
          let offset = timezone.offset || null;
          return $t('datetime.timezone', {
            name: timezone.id,
            hours: prefix + utils.convertMinutes(Math.abs(offset))
          });
        }

        function initSelectedCountryAndState() {
          if ($scope.organization.country && $scope.organization.country.id) {
            $scope.helpers.selectedCountryId = $scope.organization.country.id;
          }
          if ($scope.organization.state && $scope.organization.state.id) {
            $scope.helpers.selectedStateId = $scope.organization.state.id;
          }
        }

        /**
         * Returns the object with current information
         * based on the form fields
         * @returns {*}
         */
        function prepareOrganizationInfo() {
          let orgInfo = {};

          if ($scope.helpers.selectedCountryId) {
            orgInfo.country = {
              'id': $scope.helpers.selectedCountryId
            };

            if ($scope.helpers.selectedStateId) {
              orgInfo.state = {
                'id': $scope.helpers.selectedStateId || null
              };
            }

            if ($scope.helpers.selectedTimezoneId) {
              orgInfo.timezone = {
                'id': $scope.helpers.selectedTimezoneId
              };
            }
          }

          if ($scope.helpers.selectedBrandId) {
            orgInfo.brand = $scope.helpers.selectedBrandId;
          }

          if ($scope.organization) {
            ORGANIZATION_INFO.forEach(propName => {
              orgInfo[propName] = $scope.organization[propName];
            });
          }

          return orgInfo;
        }

        function canSaveOrganization() {
          if (!$scope.organization) {
            return false;
          }

          let orgInfo = prepareOrganizationInfo();

          let country = $scope.organization && $scope.organization.country && ($scope.organization.country.id === $scope.helpers.selectedCountryId);
          let state = $scope.organization && (($scope.organization.state && $scope.organization.state)
            ? $scope.organization.state.id === $scope.helpers.selectedStateId
            : !$scope.helpers.selectedStateId);
          let countryFlag = angular.isUndefined(country) || country;
          let stateFlag = angular.isUndefined(state) || state;
          let brandFlag = $scope.organization && $scope.organization.brand === $scope.helpers.selectedBrandId;

          let organization = angular.copy($scope.dataProvider.organizationResource.value);
          if (countryFlag && stateFlag && brandFlag && utils.compareFormObjects(orgInfo, organization, ORGANIZATION_INFO)) {
            return false;
          }

          return true;
        }

        function saveOrganization() {
          $('#form-info').form('validate form');
          if (!$('#form-info').form('is valid')) {
            $scope.loading = false;
            return false;
          }

          $scope.loading = true;
          let orgInfo = prepareOrganizationInfo();

          return $q.when($scope.dataProvider.saveOrganizationInfo(orgInfo))
            .then(() => {
              ToastsService.success();
              initOrganizationInfoModel();
              $scope.loading = false;
            });
        }

        /**
         * Reload edit page with parent org
         * @param {*} organization
         */
        function switchOrg(organization) {
          if (!$scope.canIViewParent) {
            return;
          }
          utils.setStorageItem(SELECTED_ORG_LOCAL_STORAGE_KEY, organization);
          $state.reload();
        }

        function initBrandsList() {
          // Allow to manage brands only for unlimited admins
          $scope.brandEditor = PermissionsService.isUnlimitedAdmin();

          if ($scope.brandEditor) {
            $scope.brands = $scope.dataProvider.brandsResource.init()
              .then(() => {
                $scope.brands = angular.copy($scope.dataProvider.brandsResource.value) || [];
                $scope.helpers.selectedBrandId = $scope.organization.brand || null;
              });
          }
        }

        function onCancelButtonClick() {
          $scope.dataProvider.activeTab = 'contacts';
          return;
        }

      }
    };
  })
  .name;
